import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Avatar, Typography } from '@blade/ui-kit'

interface CreatedByProps extends React.ComponentPropsWithoutRef<typeof Root> {
  address: string
  avatar?: string
}

export const CreatedBy = ({ address, avatar, ...props }: CreatedByProps) => {
  const { t } = useTranslation()
  return (
    <Root {...props}>
      <Title>{t('fun.created-by')}:</Title>
      <UserWrapper>
        <AvatarAddress>
          <Avatar src={avatar ?? ''} alt={address} size={16} />
          <Address>{address}</Address>
        </AvatarAddress>
      </UserWrapper>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

const Title = styled.p`
  color: var(--text-10);
  font-weight: 500;
  font-size: 11px;
`

const UserWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

const AvatarAddress = styled.div`
  gap: 4px;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
`

const Address = styled(Typography)`
  color: var(--white);
  font-weight: 600;
  font-size: 11px;
  width: 65px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`
